import React from 'react';
import { Card } from '../components/ui/display/Card.jsx';
import { tFor, pickLocalized } from '../i18n/i18n.js';
import { formatBaht } from '../lib/price.js';

// Extras picker. Each extra row has a +/- qty stepper (min 0, max 99).
// The orchestrator passes the qty map and the extras list — this step is
// presentational.

export function StepExtras({ extras, quantities, onChange, locale }) {
  const t = tFor(locale);
  if (!extras || extras.length === 0) {
    return null;
  }
  return (
    <Card title={t('extras.heading')}>
      {extras.map((extra) => {
        const qty = quantities[extra.id] || 0;
        const label = pickLocalized(extra.translations, locale);
        return (
          <div key={extra.id} className="sp-extra">
            <div className="sp-extra__body">
              <div className="sp-extra__title">{label}</div>
              <div className="sp-extra__price">
                {extra.price > 0 ? `+${formatBaht(extra.price)}` : 'Free'}
              </div>
            </div>
            <div className="sp-qty">
              <button
                type="button"
                className="sp-qty__btn"
                onClick={() => onChange(extra.id, Math.max(0, qty - 1))}
                disabled={qty === 0}
                aria-label="Decrease quantity"
              >
                −
              </button>
              <span className="sp-qty__count">{qty}</span>
              <button
                type="button"
                className="sp-qty__btn"
                onClick={() => onChange(extra.id, Math.min(99, qty + 1))}
                aria-label="Increase quantity"
              >
                +
              </button>
            </div>
          </div>
        );
      })}
    </Card>
  );
}
